export default "__VITE_ASSET__CXQ62V3x__"